// extracted by mini-css-extract-plugin
export var line = "style-module--line--9c7c7";
export var lineWrap = "style-module--line-wrap--e233a";
export var marquee = "style-module--marquee--a1f37";
export var numsList = "style-module--nums-list--36544";
export var res = "style-module--res--3cb27";
export var scroll = "style-module--scroll--ef0ff";